import classNames from "classnames";
import ToolTip from "components/design/toolTip";
import { CaretDown } from "components/icons/CaretDown";
import dayjs from "dayjs";
import { DISPLAY_DATE } from "constants/date";
import { useState } from "react";
import { PreviousAnswerRound } from "types/Models/chatQnA";
import { FileObject } from "types/Models/fileObject";
import { pluralize } from "utils/pluralize";
import { FilePreviewCell } from "./FilePreviewCell";

export const PreviousResponses = ({
  rounds,
}: {
  rounds: PreviousAnswerRound[];
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (rounds.length === 0) return null;

  const latestRound = rounds[0];
  const previousResponsesLabel = `Previous ${pluralize(
    rounds.length,
    "response",
    "responses",
    false
  )} (${rounds.length})`;

  const trigger = (
    <button
      type="button"
      className="all:unset t-flex t-items-center t-gap-1 t-cursor-pointer t-text-caption t-text-neutral-50 t-min-w-0 t-max-w-full"
      onClick={() => setIsOpen((prev) => !prev)}
    >
      <span
        className={classNames(
          "t-shrink-0 t-text-neutral-50 t-transition-transform",
          { "-t-rotate-90": !isOpen }
        )}
      >
        <CaretDown width="10" height="10" />
      </span>
      <span className="t-truncate">
        {isOpen
          ? previousResponsesLabel
          : `${previousResponsesLabel}: ${latestRound.question}`}
      </span>
    </button>
  );

  return (
    <div className="t-flex t-flex-col t-gap-2">
      {isOpen ? (
        trigger
      ) : (
        <ToolTip text="Click to view complete thread" side="top">
          {trigger}
        </ToolTip>
      )}

      {isOpen && (
        <div className="t-flex t-flex-col t-gap-3 t-py-2 t-pl-2 t-border-0 t-border-l-2 t-border-solid t-border-neutral-20">
          {rounds.map((round, index) => (
            <div
              key={round.uuid}
              className={classNames(
                "t-flex t-flex-col t-gap-1",
                index < rounds.length - 1 &&
                  "t-pb-3 t-border-0 t-border-b t-border-dashed t-border-neutral-10"
              )}
            >
              <p className="t-m-0 t-text-caption t-text-neutral-50">
                {round.question}
              </p>
              <p className="t-m-0 t-text-caption t-text-neutral-70">
                {round.answer}
              </p>
              {round.documents.map((doc) => (
                <FilePreviewCell
                  key={doc.uuid}
                  file={{
                    ...doc,
                    uuid: doc.file_uuid,
                    file_type: doc.file_type as FileObject["file_type"],
                  }}
                />
              ))}
              {round.answered_at && (
                <p className="t-m-0 t-text-caption-italic t-text-neutral-50 t-italic">
                  Answered on {dayjs(round.answered_at).format(DISPLAY_DATE)}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
